import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
// OTP Input
import OtpInput from "react-otp-input"
// React Router
import { useNavigate } from "react-router-dom"
// CSS
import { verifyOTP, verifyResetOTP, verifySignInOTP } from "../../redux/auth"
// import functions from redux API
import "../styles/OTPVerification.scss"
// password from state
import { useLocation } from 'react-router-dom';
import Button from "../buttons/Button"

const OTPVerificationComponent = () => {
  const { isLoading } = useSelector((state) => state.auth)
  const [otp, setOtp] = useState("")
  const location = useLocation();
  const mobileNumber = localStorage.getItem("afri_mobile_number")
  const navigate = useNavigate()
  
  // Gets password and isSignUp flag from navigate function after redirection
  const { password, isSignUp } = location.state || {}; 
  
  // Verifies OTP based on the flow (sign-up, sign-in, or password reset)
  const initVerifyOTP = () => {
    if (!password) {
      // Password reset flow
      verifyResetOTP(mobileNumber, otp, navigate)
    } else if (isSignUp === false) {
      // Sign-in flow
      verifySignInOTP(true, otp, password)
    } else {
      // Sign-up flow (default)
      verifyOTP(true, otp, password)
    }
  }
  
  return (
    <div className="signup">
      <wc-toast></wc-toast>
      <div className="container">
        <div className="inside-signup">
          <p> {mobileNumber} </p> <br />
          <h2> Enter Verification Code </h2>
          <div className="otp">
            <OtpInput
              value={otp}
              onChange={e => setOtp(e)}
              numInputs={6}
              separator={<span> - </span>}
            />
            <Button isLoading={isLoading} disabled={isLoading} action={() => initVerifyOTP()} label="Done"/>
          
          </div>
        </div>
      </div>
    </div>
  )
}

export default OTPVerificationComponent